/**
 * Returns the API base URL.
 *
 * Split-origin deployment (post-Emergent migration): the SPA is hosted on
 * Cloudflare Pages and the API on a separate host, so the frontend MUST call
 * the explicitly-configured backend, baked in at build time via
 * REACT_APP_BACKEND_URL:
 *   - staging: https://nsofar-staging.hcmcrm.com
 *   - prod:    https://api.nsofar.com
 *
 * Falls back to the current browser origin only when REACT_APP_BACKEND_URL is
 * unset — i.e. legacy same-origin deployments (the old Emergent setup, where
 * frontend + API shared one domain) or SSR. Previously this returned
 * window.location.origin unconditionally, which broke once SPA and API were
 * split (every /api call hit the Pages domain → 405).
 */
export function getApiUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL;
  if (configured) {
    return configured.replace(/\/+$/, '');  // strip trailing slash; callers append /api
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}
